var React = require('react');

function GooglePlayLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Google Play"),React.createElement("path",{"stroke":"none","d":"M11.8,11.4l3.6-2.1c0.4-0.2,0.4-0.6,0-0.8c-0.4-0.2-3.6-2.1-3.6-2.1L9.3,9L11.8,11.4z","opacity":".4","key":1}),React.createElement("path",{"stroke":"none","d":"M0.2,18l9.1-9L0.3,0C0.1,0.1,0,0.2,0,0.5v17.1C0,17.8,0.1,17.9,0.2,18z","key":2}),React.createElement("path",{"stroke":"none","d":"M9.3,9l-9.1,9c0.1,0,0.2,0,0.4-0.1l0.1,0c0.4-0.2,2.7-1.6,4.7-2.7l2.7-1.6l3.8-2.2L9.3,9z","opacity":".6","key":3}),React.createElement("path",{"stroke":"none","d":"M9.3,9L0.3,0c0.1,0,0.2,0,0.4,0.1l0.1,0c0.4,0.2,2.6,1.5,4.6,2.6l2.7,1.6l3.8,2.2L9.3,9z","opacity":".4","key":4})]);
}

GooglePlayLogoInline.defaultProps = {"stroke":"none","height":"18","viewBox":"0 0 16 18","width":"16"};

module.exports = GooglePlayLogoInline;

GooglePlayLogoInline.default = GooglePlayLogoInline;
